export const EXPORT_LOAD_LIST = 'EXPORT_LOAD_LIST';
export const EXPORT_LOAD_LIST_STARTED = EXPORT_LOAD_LIST + "_STARTED";
export const EXPORT_LOAD_LIST_SUCCESS = EXPORT_LOAD_LIST + "_SUCCESS";
export const EXPORT_LOAD_LIST_ERROR = EXPORT_LOAD_LIST + "_ERROR";
export const SET_EXPORT_PAGE_PAGINATION = "SET_EXPORT_PAGE_PAGINATION";

export const EXPORT_DOWNLOAD = "EXPORT_DOWNLOAD";
export const EXPORT_DOWNLOAD_STARTED = EXPORT_DOWNLOAD + "_STARTED";
export const EXPORT_DOWNLOAD_SUCCESS = EXPORT_DOWNLOAD + "_SUCCESS";
export const EXPORT_DOWNLOAD_ERROR = EXPORT_DOWNLOAD + "_ERROR";
export const EXPORT_DOWNLOAD_CLOSE = EXPORT_DOWNLOAD + "_CLOSE";

export const EXPORT_GENERATE = "EXPORT_GENERATE";
export const EXPORT_GENERATE_STARTED = EXPORT_GENERATE + "_STARTED";
export const EXPORT_GENERATE_SUCCESS = EXPORT_GENERATE + "_SUCCESS";
export const EXPORT_GENERATE_ERROR = EXPORT_GENERATE + "_ERROR";
export const EXPORT_GENERATE_CLOSE = EXPORT_GENERATE + "_CLOSE";

export const EXPORT_DELETE = "EXPORT_DELETE";
export const EXPORT_DELETE_STARTED = EXPORT_DELETE + "_STARTED";
export const EXPORT_DELETE_SUCCESS = EXPORT_DELETE + "_SUCCESS";
export const EXPORT_DELETE_ERROR = EXPORT_DELETE + "_ERROR";

export const EXPORT_DIALOG_CLOSE = "EXPORT_DIALOG_CLOSE";

export default {
    EXPORT_LOAD_LIST, EXPORT_LOAD_LIST_SUCCESS, EXPORT_LOAD_LIST_STARTED, EXPORT_LOAD_LIST_ERROR, SET_EXPORT_PAGE_PAGINATION,
    EXPORT_DOWNLOAD, EXPORT_DOWNLOAD_STARTED, EXPORT_DOWNLOAD_ERROR, EXPORT_DOWNLOAD_CLOSE, EXPORT_DOWNLOAD_SUCCESS,
    EXPORT_GENERATE, EXPORT_GENERATE_CLOSE, EXPORT_GENERATE_ERROR, EXPORT_GENERATE_STARTED, EXPORT_GENERATE_SUCCESS,
    EXPORT_DELETE, EXPORT_DELETE_STARTED, EXPORT_DELETE_SUCCESS, EXPORT_DELETE_ERROR, EXPORT_DIALOG_CLOSE
};